module.exports = __webpack_public_path__ + "static/media/wordPortraitThumb.6c013de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wordPortraitThumb.png
// module id = 202
// module chunks = 0